module.exports = __webpack_public_path__ + "img/gino.0e69c909.jpg";